<script setup>
    const props = defineProps({
        image: Object
    })
    const emits = defineEmits(['onRemove', 'onFileChange'])
</script>

<template>
    <div class="box mb-4">
        <div class="columns">
            <div class="column is-narrow">
                <div class="buttons are-small">
                    <button type="button" class="button is-danger is-light"
                            @click="emits('onRemove')">
                        <b-icon icon="delete" size="is-small"></b-icon>
                    </button>
                </div>
            </div>

            <div class="column">
                <div class="file has-name is-fullwidth mb-3">
                    <label class="file-label">
                        <input class="file-input" type="file" accept="image/*"
                               @change="emits('onFileChange', $event)">
                        <span class="file-cta">
                                            <span class="file-icon"><i
                                                class="mdi mdi-upload"></i></span>
                                            <span class="file-label">{{ $t('file_upload.select_image') }}...</span>
                                        </span>
                        <span class="file-name" v-if="image.file">{{ image.file.name }}</span>
                        <span class="file-name" v-else>{{ $t('file_upload.no_selected_file') }}</span>
                    </label>
                </div>

                <div v-if="image.preview || image.url" class="mb-3">
                    <figure class="image">
                        <img :src="image.preview || image.url" class="image-preview">
                    </figure>
                </div>

                <b-field :label="`${$t('trainings.labels.timestamp')} (mm:ss)`">
                    <b-input required
                             v-model="image.timestamp"
                             placeholder="00:00"
                             pattern="([0-9]{1,2}:)?[0-9]{1,3}:[0-9]{2}"
                             icon="clock"/>
                </b-field>
            </div>
        </div>
    </div>
</template>

<style scoped>
.image-preview {
    max-height: 125px;
    width: auto;
    object-fit: contain;
    display: block
}
</style>
